import { render } from "./M1.vue?vue&type=template&id=6cf61127&scoped=true"
import script from "./M1.vue?vue&type=script&lang=js"
export * from "./M1.vue?vue&type=script&lang=js"

import "./M1.vue?vue&type=style&index=0&id=6cf61127&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf61127"]])

export default __exports__